import { useTranslation } from "react-i18next";
import type { TmTaskPriority } from "../../api/tm";

const STYLES: Record<TmTaskPriority, { bg: string; fg: string }> = {
  LOW:    { bg: "var(--surface-muted)", fg: "var(--ink-3)" },
  MEDIUM: { bg: "var(--info-bg)", fg: "var(--info)" },
  HIGH:   { bg: "var(--warn-bg)", fg: "var(--warn)" },
  URGENT: { bg: "var(--err-bg)", fg: "var(--err)" },
};

export function TmPriorityPill({ priority }: { priority: TmTaskPriority }) {
  const { t } = useTranslation();
  // A state the browser does not know is a state the server added since this bundle was built,
  // which is exactly what a reader with an open tab sees during a release. An unknown state is
  // shown plainly rather than taking the screen down with it.
  const s = STYLES[priority] ?? { bg: "var(--surface-2)", fg: "var(--ink-2)" };
  return (
    <span style={{
      padding: "1px 8px", borderRadius: 6,
      background: s.bg, color: s.fg, fontSize: 11, fontWeight: 600, textTransform: "uppercase",
    }}>{t(`tm.priority.${priority}`, { defaultValue: priority })}</span>
  );
}
